<template lang="pug">
shListData(title="Códigos" resolver="codes" keyData="code" component="shCode")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Codes',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/code/Codes.vue